import { render } from "./MessagesRenderer.vue?vue&type=template&id=334816f5&ts=true"
import script from "./MessagesRenderer.ts?vue&type=script&lang=ts&external"
export * from "./MessagesRenderer.ts?vue&type=script&lang=ts&external"

import "./MessagesRenderer.scss?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__